//
//
//
//
//
//
//
//
//
//
//
//
//
//

import emptyCell from "../components/emptyCell";
import util from '@/lib/util';
import ComplaintList from "./components/complaintList";
import ConsultationList from "./components/consultationList";

export default {
    name: "my-complaintRecords",
    components: {ConsultationList, ComplaintList, emptyCell},
    data() {
        return {
            memberId: 0,
            list: [],
            refreshing: false,
            pageIndex: 0,
            pageSize: 10,
            loading: false,
            finished: false,
            downloadUrl: util.ApiUrl + '/file/download/',
            show: false,
            delId: 0,
            saving: false,
            active: 0
        }
    },
    methods: {

        onConfirm() {
            this.onDelete();
        },
        onShowDialog(id) {
            this.delId = 0;
            this.delId = id;
            this.show = true;

        },
        onDelete() {
            if (this.delId > 0) {
                abp.ajax.delete('/api/services/app/ComplaintRecord/DeleteComplaintRecordById?id=' + this.delId).then((res) => {
                    this.onRefresh();
                }).finally(() => {
                    // this.refreshing = false;
                    // this.loading = true;
                    this.show = false;
                });
            }
        },
        onCancelComplaint(id) {
            var page = {
                id: 0,
                complaintRecordId: id,
                operatorType: 6,
                dealWithRemark: '业主微信服务号取消',
                file: {associateType: 'ComplaintInfoFile'}
            };
            this.saving = true;
            abp.ajax.post('/api/services/app/ComplaintRecord/SaveComplaintChuLi', page).then((res) => {
                this.$toast('取消成功');
                this.onRefresh();
            }).finally(() => {
                this.saving = false;
            });
        },
        showRecordInfo(id) {
            this.$router.push({
                name: 'complaintRecordInfo',
                params: {
                    id: id
                }
            })
        },
    },
    created() {
        // this.memberId = parseInt(this.$route.params.id) || 0;
        // if (this.memberId > 0) {
        //     // this.onRefresh();
        // }
    }
}
